import React from 'react'
import AdminDashboardPage from './AdminDashboardPage'

function AdminProjectsPage() {
  return <AdminDashboardPage section="projects" />
}

export default AdminProjectsPage
